import type { FC } from 'react'
import { memo } from 'react'
import { useRaf } from 'react-use'
import dayjs from '../utils/dayjs'

const _Duration: FC<{
  startTime: Date | string
  endTime?: Date | string
  precision?: number
}> = ({ startTime, endTime, precision }) => {
  useRaf(endTime ? 0 : 1e11)

  const span = dayjs.duration(
    dayjs(endTime === null ? undefined : endTime).diff(dayjs(startTime)),
  )

  const hours = span.asHours() << 0
  const minutes = span.minutes()
  const seconds = span.seconds() + (precision ? span.milliseconds() / 1000 : 0)

  const parts: string[] = []
  if (hours > 0) parts.push(`${hours}h`)
  if (minutes > 0) parts.push(`${minutes}m`)
  if (seconds > 0) parts.push(`${seconds.toPrecision(precision)}s`)

  return <span>{parts.join(' ')}</span>
}

const Duration = memo(_Duration)

export default Duration
